import { desktopBlur, type CardDirection, type FlowThemeCardMotion } from '../../cardMotion';

/** The next card floats up off the water; the last one drifts away above. */
export const bloomCardMotion = (isMobile: boolean): FlowThemeCardMotion => ({
  variants: {
    enter: (direction: CardDirection) => ({
      opacity: 0,
      y: direction > 0 ? 72 : -56,
      scale: 0.97,
      filter: desktopBlur(isMobile, 8),
    }),
    center: { opacity: 1, y: 0, scale: 1, filter: isMobile ? undefined : 'blur(0px)' },
    exit: (direction: CardDirection) => ({
      opacity: 0,
      y: direction > 0 ? -56 : 72,
      scale: 1.02,
      filter: desktopBlur(isMobile, 8),
    }),
  },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
});
